import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { AppHeader } from "../components/AppHeader";
import { Button, Field } from "../components/UIKit";

const API = process.env.REACT_APP_BACKEND_URL;

// Neutral message returned regardless of account existence — do not customise
// per outcome, that's the whole point of the flow.
const NEUTRAL_MSG =
  "Si un compte compatible existe pour cette adresse, un lien de réinitialisation a été envoyé. Vérifiez votre boîte de réception.";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState(null);

  const onSubmit = async (e) => {
    e?.preventDefault?.();
    if (loading || submitted) return;
    setError(null);
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) {
      setError("Merci de saisir une adresse email valide.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${API}/api/auth/forgot-password`, {
        email: email.trim().toLowerCase(),
      });
      // Always show the neutral acknowledgement — even on network error we
      // do not want to reveal internal state.
      setSubmitted(true);
    } catch (err) {
      // Rate-limit or validation errors bubble up as generic messages.
      const status = err?.response?.status;
      if (status === 429) {
        setError("Trop de demandes récentes. Réessayez dans une heure.");
      } else if (status === 422) {
        setError("Adresse email invalide.");
      } else {
        // Any other error keeps the flow neutral for the user.
        setSubmitted(true);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: "var(--mf-bg)", display: "flex", flexDirection: "column" }}>
      <AppHeader background="surface" clickable={false} />
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "32px 24px calc(32px + env(safe-area-inset-bottom))" }}>
        <div style={{ width: "100%", maxWidth: 440 }} className="mf-anim-in" data-testid="forgot-password-page">
          <div style={{ marginBottom: 24, textAlign: "center" }}>
            <h2 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: "var(--mf-text)", letterSpacing: -0.4 }}>
              Mot de passe oublié
            </h2>
            <p style={{ margin: "6px 0 0", fontSize: 15, color: "var(--mf-text-secondary)" }}>
              Saisissez l'adresse email associée à votre compte My Fleet.
            </p>
          </div>

          {submitted ? (
            <div
              data-testid="forgot-password-success"
              style={{
                padding: 20, borderRadius: 12, background: "var(--mf-bg-muted)",
                border: "1px solid var(--mf-border)", color: "var(--mf-text)",
                fontSize: 15, lineHeight: 1.5, marginBottom: 20,
              }}
            >
              {NEUTRAL_MSG}
              <p style={{ margin: "12px 0 0", fontSize: 13, color: "var(--mf-text-secondary)" }}>
                Le lien de réinitialisation expire dans 30 minutes.
              </p>
            </div>
          ) : (
            <form onSubmit={onSubmit} data-testid="forgot-password-form">
              <Field
                testID="forgot-password-email-input"
                label="Email"
                type="email"
                value={email}
                onChange={setEmail}
                placeholder="vous@email.com"
                autoComplete="email"
                error={error}
              />
              <Button testID="forgot-password-submit-button" type="submit" loading={loading}>
                Envoyer le lien de réinitialisation
              </Button>
            </form>
          )}

          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Link
              to="/login"
              data-testid="forgot-password-goto-login"
              style={{ color: "var(--mf-text-secondary)", fontSize: 14, textDecoration: "none" }}
            >
              Retour à la <span style={{ color: "var(--mf-brand)", fontWeight: 700 }}>connexion</span>
            </Link>
          </div>

          <p style={{ marginTop: 32, fontSize: 12, color: "var(--mf-text-muted)", textAlign: "center", lineHeight: 1.6 }}>
            My Fleet ne vous communiquera jamais votre ancien mot de passe.
          </p>
        </div>
      </div>
    </div>
  );
}
